<template>
  <div class="mbox">
    <Header />
    <div class="main">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
export default {
  name: "MainPage",
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="less">
.mbox {
  // display: flex;flex-direction: column;min-height:100vh;
}
.main {
  min-height: calc(100vh - 130px)
}
</style>
